import React from 'react';
import { Edit, SimpleForm, TextInput, ReferenceInput, SelectInput, required, SaveButton, Toolbar, useInput } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { AudioFileInput } from '../inputs/AudioFileInput';
import { AutoCropFileInput } from '../inputs/AutoCropFileInput';

const CustomToolbar = () => {
  const { watch } = useFormContext();
  const audioFile = watch('audio_file');
  const hasAudioFile = audioFile && (audioFile.isExisting || audioFile.src || audioFile.rawFile);
  
  return (
    <Toolbar>
      <SaveButton disabled={!hasAudioFile} />
    </Toolbar>
  );
};

export const ContentEdit = () => (
    <Edit title="Edit audio content" actions={false} redirect="list">
      <SimpleForm toolbar={<CustomToolbar />}>
        <TextInput source="title" label="Name" required />
        <TextInput source="description" label="Description" multiline rows={3} />
        <ReferenceInput
            source="content_type_id"
            reference="content_types"
            label="Content Type"
            required
            allowEmpty
            perPage={100}
            sort={{ field: 'display_name', order: 'ASC' }}
            filter={{ id: { $exists: true } }}
        >
          <SelectInput
              optionText="display_name"
              emptyText="Select content type..."
              emptyValue=""
              validate={[required('Content type is required')]}
          />
        </ReferenceInput>

        <ReferenceInput
            source="category_id"
            reference="categories"
            label="Category"
            required
            allowEmpty
            perPage={100}
            sort={{ field: 'name', order: 'ASC' }}
            filter={{ id: { $exists: true } }}
        >
          <SelectInput
              optionText="name"
              emptyText="Select category..."
              emptyValue=""
              validate={[required('Category is required')]}
          />
        </ReferenceInput>

        <AudioFileInput
            source="audio_file"
            label="Audio file"
            placeholder="Select MP3 or M4A audio file (max 500MB)"
          />

          <AutoCropFileInput
            source="cover_image"
            label="Cover Image"
          />

        <TextInput
            source="duration_seconds"
            label="Duration (sec)"
            type="number"
            style={{ display: 'none' }}
            helperText="Duration is determined automatically from audio file"
        />
      </SimpleForm>
    </Edit>
);

